import { render } from "./AiTextUsDepartments.vue?vue&type=template&id=1e60feb9&scoped=true"
import script from "./AiTextUsDepartments.vue?vue&type=script&lang=js"
export * from "./AiTextUsDepartments.vue?vue&type=script&lang=js"

import "./AiTextUsDepartments.vue?vue&type=style&index=0&id=1e60feb9&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e60feb9"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiTextUsDepartments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e60feb9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e60feb9', __exports__)) {
    api.reload('1e60feb9', __exports__)
  }
  
  module.hot.accept("./AiTextUsDepartments.vue?vue&type=template&id=1e60feb9&scoped=true", () => {
    api.rerender('1e60feb9', render)
  })

}


export default __exports__